// extracted by mini-css-extract-plugin
export default {"cookiesBanner":"L7RIiKKM","link":"aGbl64gN"};